// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import videoRoom from './plugins/videoroom';
import shakaPlayer from './plugins/shakaplayer';
import volumeMeter from './plugins/volume-meter';
import store from './store/store';
import "./sass/base.scss";

Vue.use(volumeMeter);
Vue.use(shakaPlayer);
Vue.use(videoRoom, {
    server: 'wss://janus2.reactoo.co.uk:8989',
    iceServers:[
        {
            'url': 'stun:stun.l.google.com:19302'
        },
        {
            'url': 'stun:turn.quickblox.com',
            'username': 'quickblox',
            'credential': 'baccb97ba2d92d71e26eb9886da5f1e0'
        },
        {
            'url': 'turn:turn.quickblox.com:3478?transport=udp',
            'username': 'quickblox',
            'credential': 'baccb97ba2d92d71e26eb9886da5f1e0'
        },
        {
            'url': 'turn:turn.quickblox.com:3478?transport=tcp',
            'username': 'quickblox',
            'credential': 'baccb97ba2d92d71e26eb9886da5f1e0'
        }
    ]
});

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: '#rwt-plugin-container',
  router, store,
  components: { App },
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js